import { FC } from 'react'
import {
  BooleanInput, Edit, SimpleForm, TextInput,
  required,
} from 'react-admin'
import { BackToOrgActions, OrgLinkEditToolbar } from '../../components'

const OrganizationUserEdit: FC = () => (
  <Edit
    mutationMode="pessimistic"
    redirect={false}
    actions={<BackToOrgActions tabPath="users" />}
  >
    <SimpleForm toolbar={
      <OrgLinkEditToolbar confirmContentKey="delete.confirmContentUser" tabPath="users" />
    }>
      <TextInput source="username" label="data.username" fullWidth validate={required()} />
      <TextInput source="display_name" label="data.displayName" fullWidth validate={required()} />
      <TextInput source="auth0_email" label="data.auth0Email" fullWidth validate={required()} type="email" />
      <TextInput source="description" label="data.description" fullWidth />
      <BooleanInput source="enabled" label="data.enabled" />
    </SimpleForm>
  </Edit>
)

export default OrganizationUserEdit
